import { useLocation } from "react-router-dom";
import { JsonLd } from "./JsonLd";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from "../../lib/site";
import { useSettings } from "../../lib/useCMS";

// Site-wide JSON-LD: SportsActivityLocation/Organization + WebSite. Mounts
// once at the App level (above Routes). Per-page schemas (Person, Service,
// Book, etc.) are emitted by the individual pages.
export const SiteJsonLd = () => {
  const settings = useSettings({});
  const location = useLocation();

  // Only emit on public routes, not /admin/*
  if (location.pathname.startsWith("/admin")) return null;

  const sameAs = [settings.instagram_url, settings.square_booking_url].filter(Boolean);

  const organization = {
    "@context": "https://schema.org",
    "@type": ["SportsActivityLocation", "Organization"],
    "@id": `${SITE_URL}/#organization`,
    name: SITE_NAME,
    alternateName: "BDH",
    url: SITE_URL,
    logo: {
      "@type": "ImageObject",
      url: settings.logo_url || DEFAULT_OG_IMAGE,
    },
    image: DEFAULT_OG_IMAGE,
    description:
      "Defensemen-specific hockey development with Coach Mike Fournier. On-ice clinics, individualized training, and fully remote video review.",
    email: settings.contact_email || "mike@builtdifferenthockey.com",
    sameAs,
    founder: {
      "@type": "Person",
      "@id": `${SITE_URL}/coach#mike-fournier`,
      name: "Mike Fournier",
      jobTitle: "Founder and Head Coach",
    },
    sport: "Ice hockey",
  };

  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${SITE_URL}/#website`,
    url: SITE_URL,
    name: SITE_NAME,
    publisher: { "@id": `${SITE_URL}/#organization` },
    inLanguage: "en-US",
  };

  return (
    <>
      <JsonLd id="organization" data={organization} />
      <JsonLd id="website" data={website} />
    </>
  );
};
